import { z } from 'zod';
import { accountFieldSchemas } from '@/features/account/shared/types/account-field-schemas';

export const resetPasswordFormSchema = z.object({
  email: accountFieldSchemas.buildEmail(),
});

export type ResetPasswordFormValues = z.infer<typeof resetPasswordFormSchema>;
